import { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";

export const ChangePasswordButton = () => {
  const [open, setOpen] = useState(false);
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const save = async () => {
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: next });
      toast.success("Password aggiornata");
      setOpen(false); setCur(""); setNext("");
    } catch (e) { toast.error(typeof e?.response?.data?.detail === "string" ? e.response.data.detail : "Operazione non riuscita"); }
  };
  return (
    <>
      <Button variant="ghost" size="icon" className="h-8 w-8" onClick={() => setOpen(true)} title="Cambia password" data-testid="change-password-btn">
        <KeyRound className="h-4 w-4" />
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm" data-testid="change-password-dialog">
          <DialogHeader><DialogTitle>Cambia password</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div className="space-y-1.5"><Label>Password attuale</Label><Input type="password" value={cur} onChange={(e) => setCur(e.target.value)} data-testid="current-password" /></div>
            <div className="space-y-1.5"><Label>Nuova password (min. 8 caratteri)</Label><Input type="password" value={next} onChange={(e) => setNext(e.target.value)} data-testid="new-password" /></div>
          </div>
          <DialogFooter><Button onClick={save} disabled={!cur || next.length < 8} data-testid="change-password-save">Salva</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
